import React from "react";
import Header from "components/Header";
//import SideBar from "components/SideBar";
import Content from "components/Content";

function PageLayout({children}) {
    return (
        <section>
            <Header />
            {/*<SideBar />*/}

            <Content>
                {children}
            </Content>
        </section>
    );
}

export default PageLayout;
